// extracted by mini-css-extract-plugin
export default {"card":"Card_card__9EsCt","header":"Card_header__oZsYJ","body":"Card_body__a+l1L","footer":"Card_footer__SD4EW"};